import type { ContentRow } from '../types/content';

// Find the next playable item after `from`, honoring start/end scheduling
// windows and looping. Returns -1 when nothing is currently playable.
// Direct port of ActivityPlayer.findIndex().
export function findNextIndex(list: ContentRow[], from: number): number {
  if (list.length === 0) return -1;

  const now = Date.now();
  let i = from;
  const j = Math.max(from, 0);

  do {
    i++;
    if (i >= list.length) i = 0;

    const content = list[i];
    if (now >= content.startMs) {
      if (content.endMs === 0) return i;
      if (now < content.endMs) return i;
    }
  } while (i !== j);

  return -1;
}

export function isPlayable(content: ContentRow): boolean {
  const now = Date.now();
  if (now < content.startMs) return false;
  if (content.endMs !== 0 && now >= content.endMs) return false;
  return true;
}
